namespace GeniuzPOS.AdvPromo {
    export namespace VwAdvPromoBasicAndAdvActiveByPluService {
        export const baseUrl = 'AdvPromo/VwAdvPromoBasicAndAdvActiveByPlu';

        export declare function Create(request: Serenity.SaveRequest<VwAdvPromoBasicAndAdvActiveByPluRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<VwAdvPromoBasicAndAdvActiveByPluRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<VwAdvPromoBasicAndAdvActiveByPluRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<VwAdvPromoBasicAndAdvActiveByPluRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "AdvPromo/VwAdvPromoBasicAndAdvActiveByPlu/Create",
            Update = "AdvPromo/VwAdvPromoBasicAndAdvActiveByPlu/Update",
            Delete = "AdvPromo/VwAdvPromoBasicAndAdvActiveByPlu/Delete",
            Retrieve = "AdvPromo/VwAdvPromoBasicAndAdvActiveByPlu/Retrieve",
            List = "AdvPromo/VwAdvPromoBasicAndAdvActiveByPlu/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>VwAdvPromoBasicAndAdvActiveByPluService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
